import React from "react";

const BarChartSquare02 = ({ width, height, color }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      width={width || "24"}
      height={height || "24"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color || "#000000"}
        d="M8 15.5613V17.5613M12 11.5613V17.5613M16 7.56128V17.5613M7.8 21.5613H16.2C17.8802 21.5613 18.7202 21.5613 19.362 21.2343C19.9265 20.9467 20.3854 20.4877 20.673 19.9233C21 19.2815 21 18.4414 21 16.7613V8.36128C21 6.68112 21 5.84104 20.673 5.19931C20.3854 4.63482 19.9265 4.17588 19.362 3.88826C18.7202 3.56128 17.8802 3.56128 16.2 3.56128H7.8C6.11984 3.56128 5.27976 3.56128 4.63803 3.88826C4.07354 4.17588 3.6146 4.63482 3.32698 5.19931C3 5.84104 3 6.68112 3 8.36128V16.7613C3 18.4414 3 19.2815 3.32698 19.9233C3.6146 20.4877 4.07354 20.9467 4.63803 21.2343C5.27976 21.5613 6.11984 21.5613 7.8 21.5613Z"
      />
    </svg>
  );
};

export default BarChartSquare02;
